import gql from 'graphql-tag';

export default gql`
  fragment commentActivityFragment on CommentActivity {
    id
    body
    bodyPlainText
  }
`;
